import Modal from "../../_bootstrapModalExtensions";
import NotificationUtil from '../../_notificationUtil';
import Interfaces from '../../_interfaces';
import { IsNullOrWhitespace } from '../../_helpers';

export function SaveKshForm(isFinalize: boolean): void {
    let formData: JQuery.NameValuePair[] = $('#ksh-form').serializeArray();
    let jsonData: object = {};
    const configName: string = isFinalize ? 'UrlAction.FinalizeKshForm' : 'UrlAction.SaveKshForm';
    const url: string = window.ETDR_RD.appConfig[configName];

    $.each(formData, (_, field) => {
        jsonData[field.name] = field.value;
    });

    toggleDisabledState(true);

    $.ajax({
        method: 'POST',
        contentType: 'application/json',
        url: url,
        dataType: 'json',
        data: JSON.stringify(jsonData),
        success: (data: Interfaces.ValidationResponse) => {
            resetInvalidIndicators();

            if (data.success) {
                let infoText: string = isFinalize ? 'A KSH nyomtatvány véglegesítése megtörtént.' : 'A KSH nyomtatvány mentése megtörtént.';
                NotificationUtil.Info(infoText, 'Siker');
                reloadTabPage();
            } else {
                markEmptyInputsAsInvalid();

                NotificationUtil.Error(data.errorText, 'Hiba');
                toggleDisabledState(false);
            }
        },
        error: () => {
            // If the frontend server threw an exception (e.g. 404, internal server error, etc)
            NotificationUtil.Error('Hiba történt a kérés elküldésekor. Töltse újra az oldalt!', 'Hiba');

            toggleDisabledState(false);
        }
    });

    function markEmptyInputsAsInvalid() {
        $('#buildings-data-section select').each((_, elem) => {
            const value: string = $(elem).val() as string;

            if (IsNullOrWhitespace(value)) {
                $(elem).addClass("is-invalid-dropdown");
            }
        });

        $('#buildings-data-section .decimal-input').each((_, elem) => {
            const value: string = $(elem).val() as string;

            if (IsNullOrWhitespace(value)) {
                $(elem).addClass("is-invalid");
            }
        });
    }
}

export function reloadTabPage(): void {
    const pageControl: ASPxClientPageControl = ASPxClientControl.GetControlCollection().GetByName('processEdit');

    pageControl.PerformCallback('');
}

export function addBuildingDataSection(event: JQuery.TriggeredEvent): void {
    let $buildingDataSection: JQuery<HTMLElement> = $('#buildings-data-section');
    let $template: JQuery<HTMLTemplateElement> = $('#building-data-template');
    let $newElem: JQuery<HTMLElement> = $template.contents().clone() as JQuery<HTMLElement>;
    let numberOfBuildingSections: number = $buildingDataSection.children().length;
    let currentCounter: string = (numberOfBuildingSections + 1).toString();

    setCounterValue(currentCounter, event);

    setTitle();

    setNewElemAttributes();

    addNewElemToSection();

    function setTitle(): void {
        let $titleElement: JQuery<HTMLElement> = $newElem.find('.ksh-form-group-title');
        let title: string = currentCounter + $titleElement.text();

        $titleElement.text(title);
    }

    function setNewElemAttributes(): void {
        let $nocElem: JQuery<HTMLElement> = $newElem.find('.noc-elem');
        let $bpElem: JQuery<HTMLElement> = $newElem.find('.bp-elem');
        let $hasFlatElem: JQuery<HTMLElement> = $newElem.find('.has-flat-elem');
        let $ufaElem: JQuery<HTMLElement> = $newElem.find('.ufa-elem');
        let $fufaElem: JQuery<HTMLElement> = $newElem.find('.fufa-elem');
        let $flatStepper: JQuery<HTMLElement> = $newElem.find('.flat-stepper');

        $nocElem.find('label').attr('for', 'Buildings-NatureOfConstruction-' + currentCounter);
        $nocElem.find('select').attr('id', 'Buildings-NatureOfConstruction-' + currentCounter).attr('name', `Buildings[${numberOfBuildingSections}].NatureOfConstruction`);

        $bpElem.find('label').attr('for', 'Buildings-BuildingPurpose-' + currentCounter);
        $bpElem.find('select').attr('id', 'Buildings-BuildingPurpose-' + currentCounter).attr('name', `Buildings[${numberOfBuildingSections}].BuildingPurpose`);

        $hasFlatElem.find('.has-flat-yes-label').attr('for', 'Buildings_HasFlatOrHolidayUnit_True_' + currentCounter);
        $hasFlatElem.find('.has-flat-yes-input').attr('id', 'Buildings_HasFlatOrHolidayUnit_True_' + currentCounter).attr('name', `Buildings[${numberOfBuildingSections}].HasFlatOrHolidayUnit`);

        $ufaElem.find('label').attr('for', 'Buildings-UsefulFloorArea-' + currentCounter);
        $ufaElem.find('input').attr('id', 'Buildings-UsefulFloorArea-' + currentCounter).attr('name', `Buildings[${numberOfBuildingSections}].UsefulFloorArea`);

        $fufaElem.find('label').attr('for', `Buildings[${currentCounter}].Flats[0].UsefulFloorArea`);
        $fufaElem.find('input').attr('id', `Buildings[${currentCounter}].Flats[0].UsefulFloorArea`).attr('name', `Buildings[${numberOfBuildingSections}].Flats[0].UsefulFloorArea`);

        $hasFlatElem.find('.has-flat-no-label').attr('for', 'Buildings_HasFlatOrHolidayUnit_False_' + currentCounter);
        $hasFlatElem.find('.has-flat-no-input').attr('id', 'Buildings_HasFlatOrHolidayUnit_False_' + currentCounter).attr('name', `Buildings[${numberOfBuildingSections}].HasFlatOrHolidayUnit`);

        $flatStepper.attr('data-building-index', numberOfBuildingSections);
    }

    function addNewElemToSection(): void {
        $buildingDataSection.append($newElem);
    }
}

export function addFlatDataSection(event: JQuery.TriggeredEvent): void {
    let $flatsSection: JQuery<HTMLElement> = getBuildingOrFlatSection(event, true);
    let $template: JQuery<HTMLTemplateElement> = $('#useful-floor-area-template');
    let $newElem: JQuery<HTMLElement> = $template.contents().clone() as JQuery<HTMLElement>;
    let numberOfFlatSections: number = $flatsSection.children(':visible').length;
    let currentCounter: string = (numberOfFlatSections + 1).toString();

    setCounterValue(currentCounter, event);

    setNewElemAttributes();

    $flatsSection.append($newElem);
    setHasFlatOrHolidayUnitRadiobuttonToTrue();

    function setNewElemAttributes(): void {
        let $labelElem: JQuery<HTMLElement> = $newElem.find('label');
        let $inputElem: JQuery<HTMLElement> = $newElem.find('input');
        let $flatStepper: JQuery<HTMLElement> = $flatsSection.parent().find('.flat-stepper');
        let buildingIndex: number = $flatStepper.data('building-index');

        $labelElem.text(currentCounter + $labelElem.text());
        $labelElem.attr('for', 'Buildings-Flats-UsefulFloorArea-' + currentCounter);
        $inputElem.attr('id', 'Buildings-Flats-UsefulFloorArea-' + currentCounter);
        $inputElem.attr('name', `Buildings[${buildingIndex}].Flats[${numberOfFlatSections}].UsefulFloorArea`);
    }

    function setHasFlatOrHolidayUnitRadiobuttonToTrue() {
        $flatsSection.parent().find('.has-flat-yes-input').prop('checked', true);
    }
}

export function removeLastSectionElement(event: JQuery.TriggeredEvent, isFlat: boolean): void {
    let $section: JQuery<HTMLElement> = getBuildingOrFlatSection(event, isFlat);
    let numberOfElemsBeforeRemove: number = $section.children().length;
    let numberOfElemsAfterRemove: number = numberOfElemsBeforeRemove - 1;

    if (numberOfElemsBeforeRemove === 0 || isFlatCounterOnOne()) {
        return;
    }

    $section.children().last().remove();

    if (isFlat) {
        setRadiobuttonToFalseWhenLastFlatRemoved();
    }

    setCounterValue(numberOfElemsAfterRemove.toString(), event);

    function isFlatCounterOnOne(): boolean {
        return isFlat && numberOfElemsBeforeRemove === 1;
    }

    function setRadiobuttonToFalseWhenLastFlatRemoved() {
        if (numberOfElemsAfterRemove == 0) {
            $section.parent().find('.has-flat-no-input').prop('checked', true);
        }
    }
}

export function handleNeedToFillFormResponse() {
    const needToFillForm: boolean = $('#need-to-fill-form-true').prop('checked');

    let $sectionToToggle: JQuery<HTMLElement> = $('#inner-ksh-form');
    let $saveBtn: JQuery<HTMLElement> = $('#ksh-form-save-btn');
    let $buildingsDataSection: JQuery<HTMLElement> = $('#buildings-data-section');
    let $buildingCountSection: JQuery<HTMLElement> = $('#building-counter');

    if (needToFillForm) {
        $sectionToToggle.removeClass('d-none');
        $saveBtn.removeClass('d-none');
    } else {
        $saveBtn.addClass('d-none');
        $buildingCountSection.val(0);
        $buildingsDataSection.empty();
        $sectionToToggle.addClass('d-none');
    }
}

export function handleHasFlatResponse(event: JQuery.TriggeredEvent) {
    let $radioBtnGroup: JQuery<HTMLElement> = $(event.currentTarget).parent().parent();
    const hasFlat: boolean = $radioBtnGroup.find('.has-flat-yes-input').prop('checked');

    let $sectionToToggle: JQuery<HTMLElement> = $radioBtnGroup.parent().parent().find('.flats-section');

    if (hasFlat) {
        $sectionToToggle.removeClass('d-none');
        $sectionToToggle.find('#increase-flat-count-stepper').trigger('click');
    } else {
        $sectionToToggle.find('.stepper-input').val(0);
        $sectionToToggle.find('.flats-data-section').empty();
        $sectionToToggle.addClass('d-none');
    }
}

export function handleDecimalNumberInput(event: JQuery.TriggeredEvent) {
    let input: string = event.key;

    if (!((input >= '0' && input <= '9') || input === ',' || input === '.')) {
        event.preventDefault();
    } else if (input === '.') {
        const inputElement = event.target as HTMLInputElement;

        inputElement.value += ',';
        event.preventDefault();
    }
}

export function ConfirmKshFormFinalize() {
    Modal.showConfirmationWindowAsync(
        'Ha az Igen gombra nyom, akkor ezen a nyomtatványon megadott adatok a továbbiakban már nem lesznek szerkeszthetőek, javíthatóak!<br \\><br \\>Folytatja?',
        'Nyomtatvány véglegesítése',
        () => { SaveKshForm(true); },
        () => { },
        'Igen',
        'Nem');
}

function toggleDisabledState(isDisabled: boolean): void {
    $('#ksh-form :input').prop('disabled', isDisabled);
    $('#ksh-form :button').prop('disabled', isDisabled);
}

function setCounterValue(currentCounter: string, event: JQuery.TriggeredEvent): void {
    let $counter: JQuery<HTMLElement> = $(event.currentTarget).parent().find('input');

    $counter.val(currentCounter);
}

function getBuildingOrFlatSection(event: JQuery.TriggeredEvent, isFlat: boolean): JQuery<HTMLElement> {
    return isFlat
        ? $(event.currentTarget).parent().parent().parent().find('.flats-data-section').first()
        : $('#buildings-data-section');
}

function resetInvalidIndicators() {
    let $form: JQuery<HTMLFormElement> = $('#ksh-form');

    $form.find(".is-invalid").removeClass("is-invalid");
    $form.find(".invalid-feedback").remove();
}

$(() => {
    $(document).on('click', '#ksh-form-save-btn', (event: JQuery.TriggeredEvent) => {
        event.preventDefault();
        SaveKshForm(false);
    });

    $(document).on('click', '#ksh-form-finalize-btn', (event: JQuery.TriggeredEvent) => {
        event.preventDefault();
        ConfirmKshFormFinalize();
    });

    $(document).on('click', '#decrease-building-count-stepper', (event: JQuery.TriggeredEvent) => {
        event.preventDefault();
        removeLastSectionElement(event, false);
    });

    $(document).on('click', '#increase-building-count-stepper', (event: JQuery.TriggeredEvent) => {
        event.preventDefault();
        addBuildingDataSection(event);
    });

    $(document).on('click', '#decrease-flat-count-stepper', (event: JQuery.TriggeredEvent) => {
        event.preventDefault();
        removeLastSectionElement(event, true);
    });

    $(document).on('click', '#increase-flat-count-stepper', (event: JQuery.TriggeredEvent) => {
        event.preventDefault();
        addFlatDataSection(event);
    });

    $(document).on('keydown', '#ksh-form input', (event: JQuery.TriggeredEvent) => {
        if (event.key === 'Enter') {
            event.preventDefault();
        }
    });

    $(document).on('change', '.need-to-fill-form', (event: JQuery.TriggeredEvent) => {
        event.preventDefault();
        handleNeedToFillFormResponse();
    });

    $(document).on('change', '.has-flat-input', (event: JQuery.TriggeredEvent) => {
        event.preventDefault();
        handleHasFlatResponse(event);
    });

    $(document).on('keypress', '.decimal-input', (event: JQuery.KeyPressEvent) => {
        handleDecimalNumberInput(event);
    });
});
